import { defineComponent as _defineComponent } from 'vue'
import { Subscription, SubscriptionStatus } from '@/api/typings/billing';
import { getPlanDescription } from '@/utils/billing';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomilyPlanCard',
  props: {
    subscription: null,
    store: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    subscription: Subscription;
    store: string;
    loading?: boolean;
};



const planTitle = computed(() => {
    if (props.loading) return '';

    const inactiveStatuses: SubscriptionStatus[] = ['canceled', 'unpaid', 'incomplete', 'incomplete_expired'];

    if (!props.subscription || inactiveStatuses.includes(props.subscription.Status)) {
        return 'No active plan';
    }

    if (props.subscription.Plan) {
        const description = getPlanDescription(props.subscription.Plan);
        if (description) {
            return description;
        }
    }
    return 'Unknown Plan';
});

return { __sfc: true,props, planTitle }
}

})